import {LegacyPeriodReportBoundary} from "./Layout/LegacyPeriodReportBoundary.jsx";
import React from "react";
import {useTranslation} from "react-i18next";
import OrderDashboardLayout from "./Layout/OrderDashboardLayout.jsx";
import CouponPerformancePanel from "./TablesAndGraphs/ByFilter/CouponPerformancePanel.jsx";
import DiscountPerformanceTable from "./TablesAndGraphs/ByFilter/DiscountPerformanceTable.jsx";


function DiscountAndCouponOverviewContent({project}) {

    let {t} = useTranslation();

    // noinspection JSValidateTypes
    return <OrderDashboardLayout
        title={t('route.sales-promotions')}
    >
        <CouponPerformancePanel project={project}/>
        <DiscountPerformanceTable project={project}/>
    </OrderDashboardLayout>;
}

export default function DiscountAndCouponOverview(props) {
    return <LegacyPeriodReportBoundary project={props.project}><DiscountAndCouponOverviewContent {...props}/></LegacyPeriodReportBoundary>;
}
